import { UtilityService } from '@eforall/common';
import { GridSetup } from '@eforall/dashboard';
import { EmailJob } from '@interfaces';
import { AppService } from '../../../../../../services';
import { getActions } from './get-actions';
import { getColumns } from './get-columns';


export function getSetup(util: UtilityService, app: AppService): GridSetup<EmailJob & { updatedUTC: number }> {

	return {
		rowName: { singular: 'Email Job', plural: 'Email Jobs' },
		getRowKey: row => '' + row.jobId,
		stateKey: 'configuration-email-jobs-grid',
		actions: getActions(),
		buttons: [],
		columns: getColumns(util, app),
	}
}
